(function () {
  if (window.__codexSelectedVariantMainImageFix) return;
  window.__codexSelectedVariantMainImageFix = true;

  var targets = {
    'beginner-penguin-crochet-kit-fixed': {
      groups: ['green', 'pink', 'gray', 'purple'],
      maxImages: 2,
      aliases: {
        grey: 'gray'
      }
    },
    'beginner-crochet-animal-kit': {
      groups: ['elephant', 'hedgehog', 'fox'],
      maxImages: 5,
      aliases: {}
    }
  };

  var css = '.codex-selected-variant-main-hidden{display:none!important}.codex-selected-variant-main-only{display:block!important;visibility:visible!important;opacity:1!important}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function currentHandle() {
    var settings = window.MinimogSettings || {};
    var pathHandle = '';
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (match) pathHandle = decodeURIComponent(match[1]);
    for (var handle in targets) {
      if (settings.productHandle === handle || pathHandle === handle) return handle;
    }
    return null;
  }

  var handle = currentHandle();
  if (!handle) return;
  var cfg = targets[handle];
  var productPromise = fetch('/products/' + handle + '.js?codex_main_image=' + Date.now(), {
    credentials: 'same-origin',
    cache: 'no-store'
  }).then(function (response) {
    return response.json();
  }).catch(function () {
    return null;
  });

  function normalizeGroup(value) {
    value = String(value || '').toLowerCase();
    for (var alias in cfg.aliases) {
      if (value.indexOf(alias) !== -1) return cfg.aliases[alias];
    }
    for (var i = 0; i < cfg.groups.length; i += 1) {
      if (value.indexOf(cfg.groups[i]) !== -1) return cfg.groups[i];
    }
    return cfg.groups[0];
  }

  function selectedTextGroup() {
    var checked = document.querySelector('variant-picker input.m-product-option__input:checked, variant-picker input[name^="options"]:checked');
    if (checked) return normalizeGroup(checked.value);

    var selectedNode = document.querySelector('variant-picker .option-label--selected, variant-picker .m-product-option--label .selected-value');
    if (selectedNode) return normalizeGroup(selectedNode.textContent);

    var select = document.querySelector('variant-picker select, select[name^="options"]');
    if (select) return normalizeGroup(select.value || (select.options[select.selectedIndex] && select.options[select.selectedIndex].text));

    return cfg.groups[0];
  }

  function selectedVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    try {
      var urlId = new URLSearchParams(window.location.search).get('variant');
      if (urlId) {
        var byUrl = product.variants.find(function (variant) {
          return String(variant.id) === String(urlId);
        });
        if (byUrl) return byUrl;
      }
    } catch (error) {}

    var variantInput = document.querySelector('form[action*="/cart/add"] [name="id"], .m-product-form [name="id"]');
    var inputId = variantInput && String(variantInput.value || '');
    if (inputId) {
      var byId = product.variants.find(function (variant) {
        return String(variant.id) === inputId;
      });
      if (byId) return byId;
    }

    var group = selectedTextGroup();
    return product.variants.find(function (variant) {
      return normalizeGroup(variant.title) === group;
    }) || product.variants[0];
  }

  function selectedImage(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image;
    var group = normalizeGroup((variant && variant.title) || selectedTextGroup());
    var media = Array.isArray(product && product.media) ? product.media : [];
    var match = media.find(function (item) {
      return item && item.media_type === 'image' && normalizeGroup(item.alt || item.src) === group;
    });
    return match || null;
  }

  function selectedImages(product, variant) {
    var group = normalizeGroup((variant && variant.title) || selectedTextGroup());
    var media = Array.isArray(product && product.media) ? product.media : [];
    var images = [];
    function add(image) {
      if (!image || !image.src) return;
      var key = String(image.src).split('?')[0];
      if (images.some(function (item) { return String(item.src).split('?')[0] === key; })) return;
      images.push(image);
    }
    add(variant && variant.featured_image);
    media.forEach(function (item) {
      if (!item || item.media_type !== 'image') return;
      if (normalizeGroup(item.alt || item.src) !== group) return;
      add(item);
    });
    var fallback = selectedImage(product, variant);
    add(fallback);
    return images.slice(0, cfg.maxImages || 1);
  }

  function withWidth(url, width) {
    if (!url) return '';
    var clean = String(url).replace(/^\/\//, 'https://').replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function makeSrcset(url, widths) {
    return widths.map(function (width) {
      return withWidth(url, width) + ' ' + width + 'w';
    }).join(', ');
  }

  function mediaShell(node) {
    return node.closest('.m-product-media--item, .swiper-slide, .product__media-item') || node;
  }

  function candidateMediaNodes() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.m-product-media[data-media-alt], .m-product-media'));
    var deduped = [];
    nodes.forEach(function (node) {
      if (deduped.indexOf(node) === -1 && node.querySelector('img')) deduped.push(node);
    });
    return deduped;
  }

  function updateImageNode(mediaNode, image) {
    var img = mediaNode.querySelector('img');
    if (!img || !image || !image.src) return;
    var alt = image.alt || image.altText || img.alt || '';
    var widths = [400, 620, 690, 810, 980, 1240, 1380, 1620, 1946];
    mediaNode.setAttribute('data-media-alt', alt);
    mediaNode.setAttribute('data-media-src', withWidth(image.src, 1946));
    if (image.id) {
      mediaNode.setAttribute('data-media-id', image.id);
      mediaShell(mediaNode).setAttribute('data-media-id', image.id);
    }
    img.alt = alt;
    img.src = withWidth(image.src, 1200);
    img.srcset = makeSrcset(image.src, widths);
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('loading');
  }

  function updateSwipers() {
    Array.prototype.slice.call(document.querySelectorAll('.swiper-container, .nav-swiper-container')).forEach(function (container) {
      var swiper = container.swiper;
      if (!swiper) return;
      try {
        swiper.slideTo(0, 0);
        swiper.update();
      } catch (error) {}
    });
  }

  function updateBucket(nodes, images) {
    nodes.forEach(function (node, index) {
      var shell = mediaShell(node);
      var image = images[index];
      var keep = Boolean(image);
      shell.classList.toggle('codex-selected-variant-main-hidden', !keep);
      node.classList.toggle('codex-selected-variant-main-hidden', !keep);
      shell.classList.toggle('codex-selected-variant-main-only', keep);
      node.classList.toggle('codex-selected-variant-main-only', keep);
      if (keep) updateImageNode(node, image);
    });
  }

  function apply(product) {
    var variant = selectedVariant(product);
    var images = selectedImages(product, variant);
    if (!images.length) return;

    var mainNodes = Array.prototype.slice.call(document.querySelectorAll('.m-product-media--slider__images .m-product-media'));
    var thumbNodes = Array.prototype.slice.call(document.querySelectorAll('.m-product-media--slider__thumbnails .m-product-media'));
    if (mainNodes.length) updateBucket(mainNodes, images);
    if (thumbNodes.length) updateBucket(thumbNodes, images);
    if (!mainNodes.length && !thumbNodes.length) updateBucket(candidateMediaNodes(), images);

    if (variant && variant.id) {
      Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"] [name="id"], .m-product-form [name="id"]')).forEach(function (input) {
        input.value = variant.id;
      });
    }
    updateSwipers();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      productPromise.then(apply);
    }, 140);
  }

  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  document.addEventListener('variant:change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }

  schedule();
})();